import React, { useEffect } from "react";
import { devLog } from "../../../utils/devLog";
import { useStyles } from "../../../context/StyleContext";
import { CALLBACKS, triggerCallback } from "../../../utils/commonUtils";
import { useTranslation } from "../../../hooks/useTranslation";
import { openPixModalWindow } from "../../../utils/openPixModalWindow";
import DlocalPixForm from "./DlocalPixForm";
import { useCheckout } from "../../../context/CheckoutContext";
import { useIframeResize } from "../../../hooks/useIframeResize";

const AltruonDlocalPixForm = ({
  formData,
  itemDetails,
  billingPlatformId,
  routingEntries,
  planId,
  platformItemDetails,
  checkoutPageConfDto, checkoutProcessDto }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const sessionId = queryParams.get("session_id");
  const { styles } = useStyles();
  const { t } = useTranslation();
  const { triggerPaymentEvent } = useCheckout();

  useIframeResize({ enabled: true, padding: 40 });

  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.type === "makePayment") {
        triggerPaymentEvent();
      }

      if (event?.data?.type === "pixPaymentCompleted") {
        devLog("PIX payment completed");
      }

      if (event?.data?.type === "pixWindowClosed") {
        devLog("PIX window closed");
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [triggerPaymentEvent]);

  const handleDocumentChange = (documentNumber) => {
    window.parent.postMessage(
      {
        type: "updatePixData",
        data: { documentNumber },
      },
      "*"
    );
  };

  const handlePaymentSuccess = (response, latestSession) => {
    // openPixModalWindow(response.data, itemDetails, checkoutPageConfDto, latestSession);
  };

  const onParentCallback = (event) => {
    switch (event.type) {
      case "finalizeFormData":
        window.parent.postMessage(event, "*");
        break;

      case "actionRequired":
        triggerCallback(CALLBACKS.ACTION_REQUIRED, {
          actionType: "REDIRECT",
          redirectUrl: event.url,
          message: "Payment initiated, redirecting you to complete the process...",
        });
        break;

      case "qrCodeRequired":
        triggerCallback(CALLBACKS.ACTION_REQUIRED, {
          actionType: "QR_CODE",
          qrData: event.qrData,
          message: "Scan the QR code to complete payment.",
        });
        break;

      case "success":
        triggerCallback(CALLBACKS.SUCCESS, {
          transactionId: event.transactionId,
          message: "Payment successfully initiated.",
        });
        break;

      case "failure":
      default:
        triggerCallback(CALLBACKS.FAILURE, {
          status: "failed",
          message: event.message || t("messages.error.somethingWrong"),
        });
        break;
    }
  };

  return (
    <DlocalPixForm
      formData={formData}
      itemDetails={itemDetails}
      billingPlatformId={billingPlatformId}
      routingEntries={routingEntries}
      planId={planId}
      platformItemDetails={platformItemDetails}
      checkoutPageConfDto={checkoutPageConfDto}
      checkoutProcessDto={checkoutProcessDto}
      styles={styles}
      sessionId={sessionId}
      isEmbeddedCheckout={true}
      onDocumentChange={handleDocumentChange}
      onPaymentSuccess={handlePaymentSuccess}
      onParentCallback={onParentCallback}
    />
  );
};

export default AltruonDlocalPixForm;